"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function Hooks() {
    var _hooks = {};
    return {
        register: function (name, callback) {
            if (typeof undefined === typeof _hooks[name]) {
                _hooks[name] = [];
            }
            _hooks[name].push(callback);
        },
        execute: function (name, args) {
            if (typeof undefined !== typeof (_hooks[name])) {
                for (var i = 0; i < _hooks[name].length; ++i) {
                    if (false === _hooks[name][i](args)) {
                        break;
                    }
                }
            }
        },
    };
}
exports.default = Hooks;
